namespace app.model.terms {
  export class SearchTermsPage {
    public searchTerms: SearchTerm[];

    constructor(searchTerms: SearchTerm[]) {
      this.searchTerms = searchTerms;
    }
  }
}
